module.exports = __webpack_public_path__ + "img/index_lou_icon_8_on.f8801658.png";